import { render } from "./NewPaymentModPage.vue?vue&type=template&id=af68070c&ts=true"
import script from "./NewPaymentModPage.vue?vue&type=script&lang=ts"
export * from "./NewPaymentModPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__